module.exports = __webpack_public_path__ + "img/ntdx.b43871fd.png";